import React, { useState, useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Founder from './assets/founder.jpg';
import CoFounder from './assets/cofounder.jpg';
import CTO from './assets/cto.jpg';
import if_1 from './assets/if_1.jpg';

// (We no longer import DominatorPage)

// --- HELPER COMPONENTS ---

const DoodleArrow = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ transform: 'rotate(-10deg) scale(1.2)' }}>
    <path d="M5 12h14" /><path d="M12 5l7 7-7 7" /><path d="M8 20s-4-6 0-11" />
  </svg>
);

const Logo = () => (
    <div className="flex items-center space-x-2">
        <svg viewBox="0 0 50 50" className="w-8 h-8 sm:w-10 sm:h-10 text-[#003049] transform -rotate-12">
            <path d="M25,2C15.6,2,8,9.6,8,19c0,5.4,2.5,10.2,6.5,13.2V38h21v-5.8c4-3,6.5-7.8,6.5-13.2C42,9.6,34.4,2,25,2z" fill="#F77F00" fillOpacity="0.3" stroke="currentColor" strokeWidth="2"/>
            <path d="M23 20 C 24 25, 28 19, 29 22 S 22 28, 25 26 C 28 24, 25 29, 27 31" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M17,38v4h16v-4" stroke="currentColor" strokeWidth="2"/>
            <path d="M19,42v2h12v-2" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
        <span className="text-3xl sm:text-4xl font-extrabold text-[#003049] transform -rotate-3" style={{ fontFamily: "'Courier New', monospace" }}>
          MAKES SENSE
        </span>
  </div>
);


// --- PAGE COMPONENTS ---

const HomePage = () => {
  return (
    <>
      {/* --- HERO SECTION --- */}
      <section className="relative container mx-auto px-4 sm:px-6 py-16 md:py-20 text-center">
        <div className="absolute top-20 left-10 w-24 h-24 bg-[#F77F00] rounded-full opacity-50 blur-xl"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-[#C1121F] rounded-2xl opacity-40 blur-lg transform rotate-45"></div>
        <h2 className="text-5xl sm:text-6xl md:text-8xl font-bold text-[#003049] leading-tight" style={{ fontFamily: "'Courier New', monospace" }}>
          We connect the dots.
        </h2>
        <h3 className="text-4xl sm:text-5xl md:text-7xl font-light text-[#C1121F] mt-2 transform rotate-[-2deg]">
          (Eventually.)
        </h3>

        {/* --- MODIFIED CONTENT --- */}
        <div className="max-w-2xl mx-auto mt-8 text-lg sm:text-xl text-gray-700 space-y-6">
          <p>
            Welcome to the beautiful chaos, where <code className="bg-gray-200 px-1 rounded-md text-red-700 transform -rotate-1 inline-block">logic.js</code> frequently throws a 404 error. Our ideas are like tangled headphones—a bit messy, but the music is worth it. We don't follow best practices; we invent chaotic ones.
          </p>
          <div className="bg-[#003049] text-left text-sm text-white rounded-lg p-4 shadow-lg transform rotate-[-1deg] font-mono">
              <p><span className="text-gray-400">&#47;&#47; Our core principle, probably.</span></p>
              <p><span className="text-purple-400">const</span> <span className="text-green-300">ourProcess</span> = (<span className="text-orange-300">idea</span>) => &#123;</p>
              <p className="pl-4"><span className="text-purple-400">try</span> &#123;</p>
              <p className="pl-8"><span className="text-gray-400">&#47;&#47; TODO: Add more planning</span></p>
              <p className="pl-8"><span className="text-green-300">buildThing</span>(<span className="text-orange-300">idea</span>);</p>
              <p className="pl-8"><span className="text-blue-400">return</span> <span className="text-yellow-300">"Success!"</span>;</p>
              <p className="pl-4">&#125; <span className="text-purple-400">catch</span> (e) &#123;</p>
              <p className="pl-8"><span className="text-green-300">console</span>.<span className="text-blue-400">log</span>(<span className="text-yellow-300">"It's now a feature."</span>);</p>
              <p className="pl-4">&#125; <span className="text-purple-400">finally</span> &#123;</p>
              <p className="pl-8"><span className="text-green-300">(isAPotenialBusinessPlan) ? openSourcePartly</span>(<span className="text-orange-300">idea</span>)<span className="text-green-300"> : openSourceEverything</span>(<span className="text-orange-300">idea</span>);</p>
              <p className="pl-4">&#125;</p>
              <p>&#125;;</p>
          </div>
        </div>
        {/* --- END OF MODIFIED CONTENT --- */}
        
        <div className="mt-12 relative inline-block">
          <DoodleArrow className="w-16 h-16 text-[#F77F00] hidden sm:block absolute -top-4 -right-20 transform -scale-x-100" />
          <Link to="/mess" className="bg-[#F77F00] text-[#003049] font-bold py-3 px-8 sm:py-4 sm:px-10 text-lg sm:text-xl rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300">
            See The Mess
          </Link>
        </div>
      </section>

      {/* --- "WHAT WE DO" SECTION --- */}
      <section className="py-20 md:py-24 bg-[#D6E2E9] transform -skew-y-2">
        <div className="transform skew-y-2 container mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-xl sm:text-2xl font-normal tracking-[0.3em] sm:tracking-[0.5em] uppercase text-gray-500">Our Services</h2>
            <p className="text-4xl sm:text-5xl font-bold text-[#003049] mt-2">Stuff We're Good At</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg transform hover:-rotate-3 transition-transform duration-300">
              <div className="text-4xl font-bold text-[#C1121F] bg-[#FDF0D5] w-16 h-16 flex items-center justify-center rounded-full mb-4">?</div>
              <h3 className="text-2xl font-bold text-[#003049]">Creative Guesswork</h3>
              <p className="mt-4 text-gray-600">We replace expensive market research with highly-tuned intuition and a magic 8-ball.</p>
            </div>
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg transform hover:rotate-2 hover:scale-105 transition-transform duration-300 md:mt-10">
              <div className="text-4xl font-bold text-[#F77F00] bg-[#D6E2E9] w-16 h-16 flex items-center justify-center rounded-2xl mb-4 transform rotate-6">!</div>
              <h3 className="text-2xl font-bold text-[#003049]">Synergistic Collisions</h3>
              <p className="mt-4 text-gray-600">We smash ideas together until something brilliant (or at least interesting) falls out.</p>
            </div>
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg transform hover:rotate-1 transition-transform duration-300">
              <div className="text-4xl font-bold text-[#003049] bg-[#F77F00] w-16 h-16 flex items-center justify-center rounded-full mb-4 opacity-70">...</div>
              <h3 className="text-2xl font-bold text-[#003049]">Proactive Procrastination</h3>
              <p className="mt-4 text-gray-600">The best ideas need time to marinate. We give them plenty. We're not delaying, we're strategically waiting.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- ABOUT US BRIEF --- */}
      <section className="py-20 md:py-24 container mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-[#003049] mb-4">It started with a scribble.</h2>
        <p className="max-w-3xl mx-auto text-base sm:text-lg text-gray-700 leading-relaxed mb-8">
          We're a carefully curated collection of expert generalists, creative mavericks, and people who are really good at untangling things. We believe the best path forward isn't always a straight line.
        </p>
        <Link to="/about" className="bg-[#003049] text-white font-bold py-3 px-8 text-lg rounded-full hover:bg-[#F77F00] transition-all duration-300 transform rotate-1 hover:rotate-0">
          More About Our Mess
        </Link>
      </section>
    </>
  );
};

// --- HELPER COMPONENT FOR TEAM MEMBERS ---
const TeamMemberCard = ({ member, isActive, onCardClick }) => {
  return (
    <div
      className="group relative bg-white p-6 rounded-lg shadow-lg text-center transform hover:scale-105 transition-transform duration-300 cursor-pointer"
      onClick={() => onCardClick(member.name)}
    >
      {/* Tooltip Overlay */}
      <div
        className={`
          absolute inset-0 bg-black bg-opacity-80 rounded-lg 
          flex items-center justify-center 
          transition-opacity duration-300 
          opacity-0 pointer-events-none 
          md:group-hover:opacity-100 md:group-hover:pointer-events-auto
          ${isActive ? '!opacity-100 !pointer-events-auto' : ''}
        `}
      >
        <div className="text-white text-lg space-y-4 font-bold">
          {member.links.portfolio && (
            <a href={member.links.portfolio} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="block hover:text-[#F77F00] transition-colors">
              Portfolio
            </a>
          )}
          {member.links.linkedin && (
            <a href={member.links.linkedin} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="block hover:text-[#F77F00] transition-colors">
              LinkedIn
            </a>
          )}
          {member.links.email && (
            <a href={member.links.email} onClick={(e) => e.stopPropagation()} className="block hover:text-[#F77F00] transition-colors">
              Mail
            </a>
          )}
        </div>
      </div>

      {/* Original Card Content */}
      <div className="w-24 h-24 rounded-full mx-auto mb-4">
        <img src={member.image} alt={`A portrait of ${member.name}`} className="w-24 h-24 rounded-full mx-auto object-cover" />
      </div>
      <h4 className="text-2xl font-bold text-[#003049]">{member.name}</h4>
      <p className="text-[#C1121F]">{member.title}</p>
      <p className="text-gray-600 mt-2">{member.description}</p>
    </div>
  );
};


const AboutUsPage = () => {
  const [activeCard, setActiveCard] = useState(null);

  const handleCardClick = (name) => {
    setActiveCard(prev => (prev === name ? null : name));
  };

  const teamMembers = [
    {
      name: 'Daksh Rawal',
      title: 'fOuNdEr & LeAd DeVeLoPeR',
      description: 'Turns simple tasks to complex. Thinks in automation.',
      image: Founder,
      links: {
        portfolio: 'https://dakksh.web.app/',
        linkedin: 'https://www.linkedin.com/in/daksh-rawal/',
        email: 'mailto:indiedev404@gmail.com'
      }
    },
    {
      name: 'Puneet Sethiya',
      title: 'Co-Founder & Web Developer',
      description: 'Keeps the beautiful chaos from turning into actual chaos.',
      image: CoFounder,
      links: {
        linkedin: 'https://www.linkedin.com/in/puneet-sethiya-7b5399374?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
        email: 'mailto:puneetsethiya16@gmail.com'
      }
    },
    {
      name: 'Dhanush Kakarla',
      title: 'CTO',
      description: 'Turning Bugs into Brilliance',
      image: CTO,
      links: {
        linkedin: 'https://www.linkedin.com/in/dhanush-chowdary',
        email: 'mailto:dhanushworkload@gmail.com',
        portfolio:'https://dhanushchowdaryk.web.app/'
      }
    },
  ];

  return (
    <div className="py-16 md:py-24 container mx-auto px-4 sm:px-6">
      <div className="text-center">
        <h2 className="text-5xl sm:text-6xl md:text-8xl font-bold text-[#003049]">Our Story</h2>
        <p className="text-xl sm:text-2xl text-[#C1121F] mt-2 transform -rotate-1">(The semi-official version)</p>
      </div>

      <div className="flex flex-col lg:flex-row items-center gap-12 mt-16 md:mt-20">
        <div className="lg:w-1/2 relative h-96 sm:h-80 w-full">
          <div className="w-full h-full bg-[#C1121F] rounded-lg shadow-xl transform rotate-[-4deg]"></div>
          <div className="w-full h-full bg-[#003049] rounded-lg shadow-2xl absolute top-0 left-0 p-6 flex flex-col justify-center transform rotate-[2deg]">
            <p className="text-white text-2xl sm:text-3xl lg:text-4xl font-serif italic leading-relaxed">"Started 'Makes Sense' because nothing else did."</p>
            <p className="text-right text-[#F77F00] font-bold text-xl sm:text-2xl mt-4 sm:mt-8">- The Founder</p>
          </div>
        </div>
        <div className="lg:w-1/2 mt-8 lg:mt-0 lg:pl-10">
          <h3 className="text-3xl sm:text-4xl font-extrabold text-[#003049] mb-4">It Began On a Tuesday</h3>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
            Legend has it, our company was founded after a particularly confusing dream. We decided to lean into the absurdity. We don't just think outside the box; we're not even sure where the box is.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Our team believes the best path forward isn't always a straight line. Sometimes, it's a scribble. And that's where we shine.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            <br></br> "The deal is simple: If we strike oil, you get a barrel. Big effort, big barrel. Small effort... you get a commemorative 'I was there!' thimble."
          </p>
        </div>
      </div>

      <div className="mt-20 md:mt-24 text-center">
        <h3 className="text-4xl sm:text-5xl font-bold text-[#003049] mb-12">The Agents of Chaos</h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {teamMembers.map((member) => (
            <TeamMemberCard
              key={member.name}
              member={member}
              isActive={activeCard === member.name}
              onCardClick={handleCardClick}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// --- HELPER COMPONENT FOR PROJECT CARDS ---
const ProjectCard = ({ project, isActive, onCardClick }) => {
    return (
        <div
            className={`group relative rounded-lg overflow-hidden shadow-lg transform hover:-rotate-2 transition-transform duration-300 cursor-pointer ${project.isWIP ? 'border-2 border-dashed border-gray-400 opacity-75' : 'bg-white'}`}
            onClick={() => onCardClick(project.id)}
        >
            {/* --- MODIFIED OVERLAY --- */}
            <div className={`
                absolute inset-0 bg-black bg-opacity-80 rounded-lg
                flex items-center justify-center
                transition-opacity duration-300
                opacity-0 pointer-events-none
                md:group-hover:opacity-100 md:group-hover:pointer-events-auto
                ${isActive ? '!opacity-100 !pointer-events-auto' : ''}
            `}>
                <div className="text-white text-lg space-y-4 font-bold">
                    {project.links && project.links.map((link) => (
                        <a 
                            key={link.name} 
                            href={link.url} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            onClick={(e) => e.stopPropagation()} 
                            className="inline-block bg-[#F77F00] text-[#003049] text-base py-2 px-5 rounded-lg hover:scale-105 transition-transform"
                        >
                            {link.name}
                        </a>
                    ))}
                </div>
            </div>

            {/* Original Card Content */}
            <div className={`h-56 sm:h-64 flex flex-col items-center justify-center p-4 ${project.headerBg}`}>
                {project.headerContent}
            </div>
            <div className={`${project.isWIP ? 'bg-white' : ''} p-6`}>
                <h4 className="text-2xl font-bold text-[#003049]">{project.title}</h4>
                <p className="text-gray-600 mt-2">{project.description}</p>
            </div>
        </div>
    );
};


const SeeTheMessPage = () => {
    const [activeCard, setActiveCard] = useState(null);

    const handleCardClick = (id) => {
        setActiveCard(prev => (prev === id ? null : id));
    };

    // --- MODIFIED PROJECTS DATA ---
    const projects = [
        {
            id: 'dominator',
            title: 'The DOMinator',
            description: "Because 'premium' is just a CSS class we can help you with.",
            headerBg: 'bg-[#C1121F]',
            // MODIFIED: Changed to an <a> tag
            headerContent: (
              <a href="/the-dominator/editor.html" className="text-white text-3xl sm:text-4xl font-serif text-center transform -rotate-6">
                The<br/>DOMinator
              </a>
            ),
            links: [
                { name: 'Logs', url: 'https://github.com/daksh47/The-DOMinator/tree/main/logs' }
            ]
        },
        {
            id: 'singularity',
            title: 'The Singularity Button',
            description: "You don't want to know. But it's going to be big. Or small. We're not sure.",
            headerBg: 'bg-black',
            headerContent: <h3 className="text-white text-3xl font-mono border-4 border-red-500 p-4 transform -rotate-3">[ CLASSIFIED ]</h3>,
            links: [
                // { name: 'View [REDACTED]', url: '#' },
            ]
        },
        {
            id: 'chimera',
            title: 'Project Chimera',
            description: "Currently a myth. We're stitching it together from three other failed projects.",
            isWIP: true,
            headerBg: 'bg-gray-200',
            headerContent: (
                <>
                    <div className="text-6xl text-gray-400 animate-pulse">...</div>
                    <h3 className="text-gray-500 text-2xl font-mono text-center mt-2">WIP</h3>
                </>
            ),
            links: [
                // { name: 'Track Progress', url: '#' },
            ]
        }
    ];

    return (
        <div className="py-16 md:py-24 container mx-auto px-4 sm:px-6">
            <div className="text-center">
                <h2 className="text-5xl sm:text-6xl md:text-8xl font-bold text-[#003049]">Our Glorious Mess</h2>
                <p className="text-xl sm:text-2xl text-[#C1121F] mt-2 transform -rotate-1">(A curated collection)</p>
            </div>

            <div className="mt-16 md:mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {projects.map((project) => (
                    <ProjectCard
                        key={project.id}
                        project={project}
                        isActive={activeCard === project.id}
                        onCardClick={handleCardClick}
                    />
                ))}
            </div>
        </div>
    );
};

// --- LAYOUT COMPONENTS ---

const Header = ({ isMenuOpen, setIsMenuOpen }) => (
  <header className="absolute top-0 left-0 w-full p-4 sm:p-6 z-20">
    <div className="flex justify-between items-center">
      <Link to="/" className="transition-transform duration-200 hover:scale-105">
        <Logo />
      </Link>
      <nav className="hidden md:flex items-center space-x-8 font-bold text-[#C1121F] text-lg">
        <Link to="/about" className="hover:text-[#F77F00] transition-transform duration-200 hover:scale-110">About</Link>
        <Link to="/mess" className="hover:text-[#F77F00] transition-transform duration-200 hover:scale-110">Our Work</Link>
        {/* MODIFIED: Changed to an <a> tag */}
        <a href="/the-dominator/editor.html" className="hover:text-[#F77F00] transition-transform duration-200 hover:scale-110">DOMinator</a>
        <a href="mailto:hello@makessense.com" className="bg-[#003049] text-white py-2 px-5 rounded-full hover:bg-[#F77F00] transition-all duration-300 transform rotate-2 hover:rotate-0">
          Contact Us!
        </a>
      </nav>
      <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-3xl font-bold text-[#003049]">☰</button>
    </div>
  </header>
);

const MobileMenu = ({ isMenuOpen, setIsMenuOpen }) => {
    if(!isMenuOpen) return null;

    return (
        <div className="fixed inset-0 bg-[#003049] bg-opacity-95 z-50 flex flex-col items-center justify-center text-white space-y-8">
            <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 text-5xl font-bold">&times;</button>
            <Link to="/" className="text-4xl font-bold hover:text-[#F77F00]" onClick={() => setIsMenuOpen(false)}>Home</Link>
            <Link to="/about" className="text-4xl font-bold hover:text-[#F77F00]" onClick={() => setIsMenuOpen(false)}>About</Link>
            <Link to="/mess" className="text-4xl font-bold hover:text-[#F77F00]" onClick={() => setIsMenuOpen(false)}>Our Work</Link>
            {/* MODIFIED: Changed to an <a> tag */}
            <a href="/the-dominator/editor.html" className="text-4xl font-bold hover:text-[#F77F00]">DOMinator</a>
            <a href="mailto:indiedev404@gmail.com" className="text-2xl font-mono mt-8 text-[#FDF0D5]">indiedev404@gmail.com</a>
        </div>
    )
}

const Footer = () => (
  <footer className="bg-[#003049] text-white py-12 md:py-16">
    <div className="container mx-auto px-4 sm:px-6 text-center">
      <h3 className="text-3xl sm:text-4xl font-bold text-[#FDF0D5]">Let's Make No Sense Together.</h3>
      <p className="text-[#D6E2E9] mt-4 text-base sm:text-lg">Drop us a line. Or a doodle. We're not picky.</p>
      <div className="mt-8">
        <a href="mailto:indiedev404@gmail.com" className="text-xl sm:text-2xl md:text-3xl font-mono text-[#F77F00] hover:underline break-words">
          indiedev404@gmail.com
        </a>
      </div>
      <div className="mt-12 border-t border-[#F77F00] border-opacity-30 pt-8 flex flex-col sm:flex-row justify-between items-center text-sm text-[#D6E2E9]">
        <p className="transform -rotate-1 mb-4 sm:mb-0 text-center sm:text-left">© 2025 Makes Sense Inc. All rights reserved. Or whatever.</p>
        <div className="flex space-x-4">
          <a href="https://www.linkedin.com/company/make-s-ense" target="_blank" rel="noopener noreferrer" className="hover:text-[#F77F00]">LinkedIn ( Ironically )</a>
        </div>
      </div>
    </div>
  </footer>
);


// --- MAIN APP COMPONENT (ROUTER) ---
export default function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="bg-[#FDF0D5] text-[#333] font-sans overflow-x-hidden">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <MobileMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main className="pt-24 sm:pt-32">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/mess" element={<SeeTheMessPage />} />
          {/* MODIFIED: The route for /dominator has been removed */}
        </Routes>
      </main>
      <Footer />
    </div>
  );
}